// extracted by mini-css-extract-plugin
export var numpadContainer = "_s3-1";
export var phoneButton = "_s3-0";